import React, { useContext, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useLocation } from 'react-router-dom';
import './Products.css';
import LoadingSpinner from '../Shared/LoadingSpinner';
import AppContext from './AppContext';
import { requestCanceller } from '../../service/axiosCancelToken';
import LoadingBar from '../Shared/ScrollLoadingBar';
import Product from './Product';
import { getProducts } from '../../service/menuOnlineService';
// import config from '../../config.json';
// const showPrice = config.showPrice.split('_')[1] === 'true' ? true : false;;


const Archive = () => {
    const { state } = useLocation();
    const [items, setItems] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [lastProductObj, setLastProductObj] = useState();
    const [hasMore, setHasMore] = useState(true);
    const perPage = 30;
    const appContext = useContext(AppContext);



    useEffect(() => {
        if(!state || !state.companyId)
            return;
        const cancelRequest = requestCanceller();

        const fetchAllProducts = async () => {
            try {
                const params = {
                    selectedCategoryId: state.categoryId,
                    companyId: state.companyId,
                    lastProductObj: lastProductObj ? JSON.stringify(lastProductObj) : undefined,
                    perPage
                };
                let { status, data } = await getProducts(params, { cancelToken: cancelRequest.signal });
                if (status === 201)
                setItems(prev => {
                    if (!prev || !prev.length) {
                        return data.items;
                    }
                    else {
                        let allitems = prev.concat(data.items);
                        return allitems;
                    }
                })
                if (data.items.length < perPage) {
                    setHasMore(false);
                }
                setIsLoading(false);
            } catch (err) {
            }
        }

        fetchAllProducts();


        return () => {
            cancelRequest.cancel();
        }
    }, [state, lastProductObj]);

    const fetchMoreData = async () => {
        const lastProductObj = {
            priority: items[items.length - 1].priority,
            _id: items[items.length - 1]._id
        };
        setLastProductObj(lastProductObj);
    };

    useEffect(() => {
        if(!state || !state.companyId){
            return;
        }
        appContext.setLocationName(state.categoryName)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state])

    if (!state || !state.companyId) {
        window.location.href = '/not-found'
        return 
    }

    return (
        <React.Fragment>
            <div className="products-layer" id="scrollableDiv">
                {
                    (!items || isLoading) ?
                        <div style={{ height: '55vh' }}>
                            <LoadingSpinner />
                        </div>
                        :
                        <React.Fragment>
                            {
                                !items.length ?
                                    <div className='Not-Exist' style={{ minHeight: '70vh' }}>
                                        موردی برای مشاهده وجود ندارد
                                    </div>
                                    :
                                    <InfiniteScroll
                                        dataLength={items && items.length}
                                        next={fetchMoreData}
                                        hasMore={hasMore}
                                        loader={
                                            <div className="infinite-scroll-loader">
                                                <span>
                                                    <LoadingBar
                                                        type="spinningBubbles"
                                                        color="rgb(238, 172, 4)"
                                                    />
                                                </span>
                                            </div>
                                        }
                                        // endMessage={
                                        //     <p className="end-message-infinite-scroll">
                                        //         <b>The End</b>
                                        //     </p>
                                        // }
                                        scrollableTarget="scrollableDiv"
                                    >
                                        {
                                            items.map(item =>
                                                <Product
                                                    key={item._id}
                                                    data={item}
                                                    currencyType={state.currencyType}
                                                    companyId={state.companyId}
                                                />
                                            )
                                        }
                                    </InfiniteScroll>
                            }
                        </React.Fragment>
                }
            </div>
        </React.Fragment>
    );
}

export default Archive;